class CustomQuantityAddToCart extends HTMLElement {
    #input;
    #productId;
    #maxQty;
    #prevQty;
    #controller = new AbortController();
    #additional;

    get #increaseBtn() { return this.querySelector('.custom-increase-button'); }
    get #decreaseBtn() { return this.querySelector('.custom-decrease-button'); }
    get #quantity() { return parseInt(this.#input.value); }

    connectedCallback() {
        const { signal } = this.#controller;
        this.#productId = this.dataset.productId;
        this.#maxQty = parseInt(this.dataset.maxQty) || Infinity;
        const initialQty = parseInt(this.dataset.quantity) || 0;
        this.#prevQty = initialQty;

        this.#additional = this.dataset.additional !== undefined;

        if (this.#additional && this.#prevQty === 0) {
            this.innerHTML = `
                <button type="button" class="custom-add-to-cart-button upgrade-option">
                    Upgrade
                </button>
            `;
            this.querySelector('.custom-add-to-cart-button.upgrade-option')
                .addEventListener('click', this.#handleFirstAdd, { signal });
        } else {
            this.#renderQuantity(initialQty);
        }
    }

    disconnectedCallback() {
        this.#controller.abort();
    }

    #renderQuantity(initialQty) {
        const { signal } = this.#controller;


        this.innerHTML = `
             <div class="quantity-wrapper">
                <button type="button" class="custom-decrease-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M15.0488 10.9961L6.95117 10.9961" stroke="#193074" stroke-width="1.2" stroke-linecap="round"/>
</svg>
</button>
                <input type="number" class="quantity-input" value=${initialQty} min="0" readonly>
                <button type="button" class="custom-increase-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M10.9971 6.95117L10.9971 15.0488" stroke="#193074" stroke-width="1.2" stroke-linecap="round"/>
  <path d="M15.0488 10.9971L6.95117 10.9971" stroke="#193074" stroke-width="1.2" stroke-linecap="round"/>
</svg>
</button>
            </div>
        `;

        this.#input = this.querySelector('.quantity-input');

        this.#increaseBtn.addEventListener('click', this.#handleIncrease, { signal });
        this.#decreaseBtn.addEventListener('click', this.#handleDecrease, { signal });

        this.#updateButtons();
    }

    #updateCart(quantity) {
        const method = this.#prevQty === 0 ? '/cart/add.js' : '/cart/change.js';
        const body = this.#prevQty === 0
            ? { id: this.#productId, quantity: 1 }
            : { id: this.#productId, quantity: quantity };

        return fetch(method, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        })
            .then(res => res.json())
            .then(data => {console.log('Cart updated', data)
                window.updateCustomCartSummary()
            })
            .catch(err => console.error(err));
    }

    #handleFirstAdd = () => {
        this.#updateCart(1).then(() => {
            this.#prevQty = 1;
            this.#renderQuantity(1);
        });
    };

    #updateButtons() {
        this.#increaseBtn.disabled = this.#quantity >= this.#maxQty;
        this.#decreaseBtn.disabled = this.#quantity <= 0;
    }

    #handleIncrease = () => {
        if (this.#quantity < this.#maxQty) {
            const newQty = this.#quantity + 1;
            this.#input.value = newQty;
            this.#updateCart(newQty).then(() => {
                this.#updateButtons();
                this.#prevQty = newQty;
            });
        }
    };

    resetQuantity() {
        if (this.#input) {
            this.#input.value = 0;
            this.#prevQty = 0;
            this.#updateButtons();
        }
    }

    #handleDecrease = () => {
        if (this.#quantity > 0) {
            const newQty = this.#quantity - 1;
            this.#input.value = newQty;
            this.#updateCart(newQty).then(() => {
                this.#updateButtons();
                this.#prevQty = newQty;
            });

        }
    };
}

if (!customElements.get('custom-quantity-add-to-cart')) {
    customElements.define('custom-quantity-add-to-cart', CustomQuantityAddToCart);
}
